import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get door list
export const getFSDoorList = async (fs_feature_id: number) => {
  try {
    const response = await apiClient.get(`/api/fs-door-list/${fs_feature_id}`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    console.error("Error fetching data:", error);

    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get door size list
export const getFSDoorSizeList = async () => {
  try {
    const response = await apiClient.get(`/api/fs-door-size-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    console.error("Error fetching data:", error);

    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create Door
export const fsDoorCreate = async (
  fs_data_id: number,
  color_id: number,
  fire_resistance_rating: string | null,
  size_type: string,
  size_id: number | null,
  manual_size: string | null,
  number: number,
  status: string,
  note: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const formData = new FormData();
    formData.append("fs_data_id", String(fs_data_id));
    formData.append("color_id", String(color_id));

    if (fire_resistance_rating !== null) {
      formData.append("fire_resistance_rating", fire_resistance_rating);
    }

    formData.append("size_type", size_type);

    if (size_id !== null) {
      formData.append("size_id", String(size_id));
    }

    if (manual_size !== null) {
      formData.append("manual_size", manual_size);
    }

    formData.append("number", String(number));
    formData.append("status", status);

    if (note !== null) {
      formData.append("note", note);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-door/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update Door
export const fsDoorUpdate = async (
  id: number,
  color_id: number,
  fire_resistance_rating: string | null,
  size_type: string,
  size_id: number | null,
  manual_size: string | null,
  number: number,
  status: string,
  note: string | null,
  image_path: File | null,
  file_list: File[] | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const formData = new FormData();

    formData.append("color_id", String(color_id));

    if (fire_resistance_rating !== null) {
      formData.append("fire_resistance_rating", fire_resistance_rating);
    }

    formData.append("size_type", size_type);

    if (size_id !== null) {
      formData.append("size_id", String(size_id));
    }

    if (manual_size !== null) {
      formData.append("manual_size", manual_size);
    }

    formData.append("number", String(number));
    formData.append("status", status);

    if (note !== null) {
      formData.append("note", note);
    }

    if (image_path !== null) {
      formData.append("image_path", image_path);
    }

    if (file_list !== null) {
      file_list.forEach((file, index) => {
        formData.append("file_list[]", file);
      });
    }

    const response = await fetch(`${baseURL}/api/fs-door/update/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete Door
export const fsDoorDelete = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/fs-door/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete  single file
export const fsDoorFileDelete = async (
  paint_accessory_data_id: number,
  index: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/fs-paint-file/delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ paint_accessory_data_id, index }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};